import React from "react";
import { Box } from "@mui/material";
import { colors, fonts, gradients, layout } from "../../theme/tokens";
import { sectors } from "../../data/siteData";

const SectorsGrid = () => {
  return (
    <Box
      component="section"
      sx={{ py: "56px", px: { xs: "20px", md: "28px" } }}
    >
      <Box
        sx={{
          maxWidth: layout.maxWidth,
          mx: "auto",
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: ".8fr 1.2fr" },
          gap: { xs: "32px", md: "50px" },
          alignItems: "center",
        }}
      >
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Box
              sx={{ width: "26px", height: "2px", background: colors.amber }}
            />
            <Box
              sx={{
                fontFamily: fonts.display,
                fontSize: "12.5px",
                fontWeight: 600,
                letterSpacing: ".2em",
                color: colors.steelBlue,
              }}
            >
              SECTORS
            </Box>
          </Box>
          <Box
            component="h2"
            sx={{
              fontFamily: fonts.display,
              fontWeight: 700,
              fontSize: "clamp(28px,3.4vw,42px)",
              lineHeight: 1.1,
              letterSpacing: "-.02em",
              color: colors.navyInk,
              mt: "16px",
              mb: 0,
            }}
          >
            Expertise across the whole economy
          </Box>
          <Box
            sx={{
              fontFamily: fonts.body,
              fontSize: "16px",
              lineHeight: 1.65,
              color: colors.mutedText,
              mt: "18px",
            }}
          >
            Our platform lets us assemble teams of experts to deliver
            best-in-class solutions in any sector, including the oil and gas
            industry.
          </Box>
        </Box>

        <Box sx={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
          {sectors.map((s) => (
            <Box
              key={s}
              sx={{
                background: "#fff",
                border: `1px solid ${colors.line}`,
                borderRadius: "40px",
                p: "14px 22px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                fontFamily: fonts.body,
                fontWeight: 600,
                fontSize: "15px",
                color: colors.brandNavy,
              }}
            >
              <Box
                sx={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  background: gradients.amber,
                }}
              />
              {s}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default SectorsGrid;
